import footerImage from 'src/assets/footerImage.png'

import axios from 'axios'
import { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { APP_CONSTANTS } from 'src/consumer/constants'
import logo from 'src/assets/logo_brand.png'
import { LocalizationContext } from 'src/consumer/context/LocalizationContext'
import { apiURL, commonHeadersWeb } from 'src/consumer/services'
import forgotPasswordImage from 'src/assets/forgotPass_Image.png'
import { isSuccessResponse, RESEND_COOLDOWN_SECONDS } from './passwordResetUtils'
import './ForgotPasswordStyles.css'

const Thankyou = (props) => {
  const pageId = 'forgotPasswordPage'

  const { localizedData } = useContext(LocalizationContext)
  const localizedStrings = localizedData?.[pageId]

  const [resending, setResending] = useState(false)
  const [resendMessage, setResendMessage] = useState('')
  const [resendError, setResendError] = useState('')
  // An email was just sent to reach this screen, so start on cooldown.
  const [cooldown, setCooldown] = useState(RESEND_COOLDOWN_SECONDS)

  useEffect(() => {
    if (cooldown <= 0) return undefined
    const timer = setTimeout(() => setCooldown((c) => c - 1), 1000)
    return () => clearTimeout(timer)
  }, [cooldown])

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (resending || cooldown > 0) return
    setResendMessage('')
    setResendError('')
    setResending(true)
    try {
      const res = await axios.get(`${apiURL}/api/user/forgot/password`, {
        params: { username: props.email },
        headers: commonHeadersWeb,
      })
      // HTTP 200 doesn't imply an email was sent — check the response code.
      if (isSuccessResponse(res?.data?.code)) {
        setResendMessage(
          localizedStrings?.password_reset_link_resent ||
          'We have re-sent the password reset link to your email.'
        )
        setCooldown(RESEND_COOLDOWN_SECONDS)
      } else {
        setResendError(
          res?.data?.message ||
          localizedStrings?.error_message ||
          'Could not resend the link. Please try again.'
        )
      }
    } catch (error) {
      setResendError(
        error?.response?.data?.message ||
        localizedStrings?.error_message ||
        'Could not resend the link. Please try again.'
      )
    } finally {
      setResending(false)
    }
  }

  const resendLabel = resending
    ? localizedStrings?.sending || 'Sending...'
    : cooldown > 0
    ? (localizedStrings?.resend_in || 'Resend in {n}s').replace('{n}', cooldown)
    : localizedStrings?.resend_password_reset_link || 'Re-send password change link.'

  return (
    <div className="forgot-password-page">
      <div className="forgot-password-container">
        <div className="forgot-password-logo">
          <img
            src={APP_CONSTANTS.APP_LOGO_LINK}
            alt="Logo"
            onError={(e) => {
              e.target.src = logo
            }}
          />
        </div>

        <div className="forgot-password-card">
          <img className="forgot-password-success-image" src={forgotPasswordImage} alt="" />
          <h1 className="forgot-password-success-title">
            {localizedStrings?.we_have_sent_you_an_email || 'We have sent you an email'}
          </h1>
          <p className="forgot-password-success-text">
            {localizedStrings?.password_reset_link_text ||
              'We have sent a password reset link to your email. Kindly check your inbox and also the spam section of your mail. If you did not receive the mail, kindly resend it below.'}
            {props.email ? (
              <span className="forgot-password-success-email">{props.email}</span>
            ) : null}
          </p>

          <div className="forgot-password-actions">
            <button
              type="button"
              className="forgot-password-submit-button"
              onClick={handleSubmit}
              disabled={resending || cooldown > 0}
            >
              {resendLabel}
            </button>

            {resendMessage && (
              <p className="forgot-password-resend-status is-success" role="status">
                {resendMessage}
              </p>
            )}
            {resendError && (
              <p className="forgot-password-resend-status is-error" role="alert">
                {resendError}
              </p>
            )}

            <Link to="/login" className="forgot-password-secondary-button">
              {localizedStrings?.go_back_to_login_page || 'Go back to login page'}
            </Link>
          </div>
        </div>
      </div>

      <div className="forgot-password-footer">
        <img src={footerImage} alt="Footer" />
      </div>
    </div>
  )
}

export default Thankyou
